import './vehicle-transaction.scss';

import { Outlet } from "react-router-dom";

import { FilterVehicleTransactionProvider } from "./filter-vehicle-transaction/filter-vehicle-transaction.context";

export function VehicleTransaction() {
  return (
    <div id="ShellVehicleTransaction" className="vehicle-transaction">
       <FilterVehicleTransactionProvider>
        <Outlet />
      </FilterVehicleTransactionProvider>
    </div>
  );
}

export default VehicleTransaction;
